import { MeetingStatusEnum } from "enums/MeetingStatusEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getMeetingStatuses(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [
    {
      value: MeetingStatusEnum.None,
      name: MeetingStatusEnum[MeetingStatusEnum.None],
      text: "None",
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: MeetingStatusEnum.Default,
      name: MeetingStatusEnum[MeetingStatusEnum.Default],
      text: i18n.MeetingStatus_Default,
      tooltip: "",
      disabled: false,
      isDefault: true,
    },
    {
      value: MeetingStatusEnum.Published,
      name: MeetingStatusEnum[MeetingStatusEnum.Published],
      text: i18n.MeetingStatus_Published,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: MeetingStatusEnum.Complete,
      name: MeetingStatusEnum[MeetingStatusEnum.Complete],
      text: i18n.MeetingStatus_Complete,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: MeetingStatusEnum.Archived,
      name: MeetingStatusEnum[MeetingStatusEnum.Archived],
      text: i18n.MeetingStatus_Archived,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: MeetingStatusEnum.Deleted,
      name: MeetingStatusEnum[MeetingStatusEnum.Deleted],
      text: i18n.MeetingStatus_Deleted,
      tooltip: "",
      disabled: true,
      isDefault: false,
    },
  ];
}
